import "./radarShart.scss"
import { Radar } from "react-chartjs-2"
import {
	Chart as ChartJS,
	RadialLinearScale,
	PointElement,
	LineElement,
	Filler,
	Tooltip,
	Legend,
} from "chart.js"
import { Box } from "@mui/material"
import ThemeCvDto from "../../../../../api/models/cvTheme"
import CvSkillDto from "../../../../../api/models/cvskill"

ChartJS.register(
	RadialLinearScale,
	PointElement,
	LineElement,
	Filler,
	Tooltip,
	Legend,
)

interface RadarChartProps {
	theme: ThemeCvDto | null
	cvSkill: CvSkillDto | null
}

function RadarChart({ theme, cvSkill }: RadarChartProps) {
	const getAtouts = (): string[] => {
		const atoutsList = [
			...(cvSkill?.poleAtouts?.map(element => element.atout) || []),
		]
		return atoutsList
	}

	const getNotes = (): number[] => {
		const atoutsNotes = [
			...(cvSkill?.poleAtouts?.map(element => Number(element.note)) ||
				[]),
		]
		return atoutsNotes
	}

	const data = {
		labels: getAtouts(),
		datasets: [
			{
				label: "",
				data: getNotes(),
				backgroundColor: `${theme?.objetColorCharteBackground}80`,
				borderColor: `${theme?.objetColorCharteBackground}`,
				borderWidth: 2,
			},
		],
	}

	const options = {
		scales: {
			r: {
				beginAtZero: true,
				ticks: {
					color: `${theme?.objetColorCharteText}`,
					backdropColor: "transparent",
					font: {
						family: `${theme?.fontFamily}`,
						size: 15,
					},
				},
				grid: {
					// color: "#000000",
				},
				pointLabels: {
					color: `${theme?.objetColorCharteText}`,
					font: {
						family: `${theme?.fontFamily}`,
						size: 15,
						color: `${theme?.objetColorCharteText}`,
					},
				},
			},
		},
		plugins: {
			legend: {
				display: false,
			},
		},
	}

	return (
		<Box sx={{ display: "flex", justifyContent: "center" }}>
			<div className="chart-radar-cv-skill">
				<Radar data={data} options={options} />
			</div>
		</Box>
	)
}

export default RadarChart
